import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { BOOKS } from "@/data/books";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("lwb-cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("lwb-cart", JSON.stringify(items));
  }, [items]);

  const add = (slug) => {
    setItems((prev) => {
      const found = prev.find((i) => i.slug === slug);
      if (found) return prev.map((i) => (i.slug === slug ? { ...i, qty: i.qty + 1 } : i));
      return [...prev, { slug, qty: 1 }];
    });
    setOpen(true);
  };

  const remove = (slug) => setItems((prev) => prev.filter((i) => i.slug !== slug));

  const setQty = (slug, qty) => {
    if (qty < 1) return remove(slug);
    setItems((prev) => prev.map((i) => (i.slug === slug ? { ...i, qty } : i)));
  };

  const detailed = useMemo(
    () =>
      items
        .map((i) => ({ ...i, book: BOOKS.find((b) => b.slug === i.slug) }))
        .filter((i) => i.book),
    [items]
  );

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = detailed.reduce((s, i) => s + i.book.price * i.qty, 0);

  return (
    <CartContext.Provider value={{ items: detailed, count, subtotal, add, remove, setQty, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
